<template>
    <template v-if="projectInfo?.designProposals.length">
        <div class="proposals__wrapper-top">
            <button  data-a11y-dialog-show="params-dialog" @click.prevent="showRoomsParametersDialog()" >
                <img src="@/assets/icons/params.svg" :alt="$t('project_settings.icon_plus')" />
                {{ $t('project_details.proposal.parameters') }}
            </button>
        </div>
        <div class="proposals__slider">
            <swiper
                :slides-per-view="3"
                :space-between="-60"
                :centered-slides="true"
                @swiper="onSwiper"
                @slideChange="onSlideChange"
                :breakpoints="breakpoints"
                @update="swiperUpdate"
            >
                <swiper-slide class="proposals__slider-item-wrapper" :id="proposal.id" v-for="(proposal,index) in projectInfo.designProposals" :key="index">
                    <div class="proposals__slider-item">
                        <div>
                            <div class="proposals__slider-top">
                                <button class="prev" @click="prevSlider">
                                    <img v-if="index > 0" src="@/assets/icons/left.svg" :alt="$t('project_details.proposal.slider_arrow_left_alt')" />
                                </button>
                                <h2>{{proposal.room}}</h2>
                                <button class="next" @click="nextSlider" >
                                    <img v-if="index+1 < projectInfo.designProposals.length" src="@/assets/icons/right.svg" :alt="$t('project_details.proposal.slider_arrow_right_alt')" />
                                </button>
                                <div class="menu">
                                    <span></span><span></span><span></span>
                                    <div>
                                        <ul>
                                            <li>
                                                <a href=""
                                                ><img
                                                    src="@/assets/icons/share.svg"
                                                    alt=""
                                                /><span>{{$t('project_details.proposal.share')}}</span></a
                                                >
                                            </li>
                                            <li>
                                                <a href=""
                                                ><img
                                                    src="@/assets/icons/print.svg"
                                                    alt=""
                                                /><span>{{$t('project_details.proposal.print')}}</span></a
                                                >
                                            </li>
                                            <li>
                                                <a href=""
                                                ><img
                                                    src="@/assets/icons/send.svg"
                                                    alt=""
                                                /><span>{{$t('project_details.proposal.send')}}</span></a
                                                >
                                            </li>
                                            <li>
                                                <a href=""
                                                ><img
                                                    src="@/assets/icons/favorites.svg"
                                                    alt=""
                                                /><span>{{$t('project_details.proposal.add_to_inspiration')}}</span></a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <h3>{{proposal.styles}}</h3>
                            <p class="proposals__slider-name">{{proposal.name}}</p>
                            <button class="proposals__slider-add-product" @click="addNewProductToProposal(proposal)">
                                <img src="@/assets/icons/admin/add.svg" width="24" height="24">
                            </button>
                            <div class="proposals__slider-products-container" style="height: 500px; overflow-y: scroll">
                                <div class="proposals__slider-products" v-for="(product,index) in proposal.products">
                                    <div class="product">
                                        <button class="product__delete-btn" title="Usuń produkt"  @click="deleteProposalProduct(product,proposal.id)">
                                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.143 11.5563L5.90039 7.31371L1.65775 11.5563L0.243536 10.1421L4.48618 5.89949L0.243536 1.65685L1.65775 0.242641L5.90039 4.48528L10.143 0.242641L11.5572 1.65685L7.3146 5.89949L11.5572 10.1421L10.143 11.5563Z" fill="#A8ACAF"/>
                                            </svg>
                                        </button>
                                        <img class="product__image" :src="product.imagePath" alt="Zdjęcie propozycji" />
                                        <div class="product__content">
                                            <h4 class="product__name">{{ product.name }}</h4>
                                            <p class="product__price">{{$t('project_details.proposal.price')}}: {{ product.price }}</p>
                                            <div class="product__actions">
                                                <!-- <div class="control control--input control-number">
                                                    <label class="control__label product__quantity"> {{$t('project_details.proposal.quantity')}}</label>
                                                    <div>
                                                        <button data-type="dec" @click="decrementProductAmount(product,proposal.id)">-</button>
                                                        <input type="text" :value="product.amount"/>
                                                        <button data-type="inc" @click="incrementProductAmount(product,proposal.id)">+</button>
                                                    </div>
                                                </div> -->
                                                <a class="product__configure"
                                                v-if="product?.shopifyUrl"
                                                :href="product.shopifyUrl.startsWith('http') ? product.shopifyUrl : '//' + product.shopifyUrl"
                                                target="_blank"
                                                >Skonfiguruj w sklepie</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div>
                            <p class="proposals__slider-item-price">{{proposal.totalValue}}</p>
    <!--                        <p class="proposals__slider-item-loan">-->
    <!--                            {{$t('project_details.proposal.instalments')}}: 24 x 360 PLN-->
    <!--                        </p>-->
                            <!-- <button class="proposals__slider-item-btn"
                                @click="addProductToShoppingCart(index)"
                            >
                                {{$t('project_details.proposal.add_to_shopping_cart')}}
                            </button> -->
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
        </div>

        <dialog-params-modal ref="roomParametersModal"/>
        <exchange-modal ref="exchangeModal"
                        @refresh-proposal="refreshProposal"
        />
        <add-product-to-proposal-model ref="addProductToPropose"
                                       @refresh-proposal="refreshProposal"
        />
        <confirm-delete-proposal-product ref="confirmDeleteProposalProduct"
                                     @deleteProduct="deleteProposalProductConfirmed"
    />
    </template>

    <template v-else>
        <h2 class="no-proposals">{{$t('project_details.proposal.empty_proposals')}}</h2>
    </template>

    <!-- <cart v-if="(auth.user.role === Role.Client || auth.user.role === Role.Architect)" /> -->

</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import {inject, onMounted, onUnmounted, ref, toRefs} from "vue";
import ExchangeModal from "@/components/projectDetails/ExchangeModal";
import DialogParamsModal from "@/components/projectDetails/DialogParamsModal";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import AlertHelper from "@/helpsers/alert.helper";
import RoomParametersModal from "@/components/architect/projectSettings/RoomParametersModal";
import ConfirmDeleteProposalProduct from "@/components/projectDetails/ConfirmDeleteProposalProduct";
import AddProductToProposalModel from "@/components/projectDetails/AddProductToProposalModal";
import Cart from "@/components/cart/Cart";
import shoppingCartService from "@/services/ShopingCart/shoppingCart.service";
import {useI18n} from "vue-i18n";
import {Role} from "@/helpsers/role.helper";
import {useAuthStore} from "@/stores/auth.store";

export default {
    name: "Proposal",
    props: {
        projectInfo: {
            type: Object,
            default: {}
        }
    },
    components: {
        Cart,
        AddProductToProposalModel,
        ConfirmDeleteProposalProduct,
        RoomParametersModal,
        Swiper,
        SwiperSlide,
        ExchangeModal,
        DialogParamsModal,
    },
    setup(props,{emit}) {
        let sw = ref(null);
        const roomParametersModal = ref(),
            exchangeModal = ref(),
            spaceBetweenSliders = ref(-60),
            {projectInfo} = toRefs(props),
            {t} = useI18n(),
            alert = inject('alert'),
            confirmDeleteProposalProduct = ref(),
            addProductToPropose = ref(),
            emitter = inject('emitter'),
            auth = useAuthStore(),
            breakpoints = {
                1299: {
                    slidesPerView: "2",
                    centeredSlides: true,
                },
                767: {
                    slidesPerView: "1",
                    centeredSlides: true,
                    spaceBetween: 10,
                },
                360: {
                    slidesPerView: "1",
                    centeredSlides: true,
                    spaceBetween: -30,

                },
            };

        function showRoomsParametersDialog() {
            roomParametersModal.value.showModal(projectInfo.value.project_rooms)
        }

        function showExchangeDialog(proposal,project) {
            exchangeModal.value.showModal(proposal,project);
        }


        const onSwiper = (swiper) => {
            sw = swiper;
            emit('update:currentSlider',swiper.slides[0].id);
        };

        const onSlideChange = (event) => {
            event.slides.map((el,index) => {
                if(index == event.activeIndex) {
                    emit('update:currentSlider', event.slides[index].id);
                }
                if(index == (event.activeIndex - 1) || index == event.activeIndex || index == (event.activeIndex + 1)) {
                    el.style.opacity = 1;
                }
                else
                    el.style.opacity = 0;

            })
        };

        function nextSlider() {
            sw.slideNext();
        }

        function prevSlider() {
            sw.slidePrev();
        }
        const keyListener = (e) => {
            /* 
            The keyboard arrow keycodes are:
            left = 37
            up = 38
            right = 39
            down = 40
            */
            if (e.keyCode === 37) {
                prevSlider()
            } else if (e.keyCode === 39) {
                nextSlider()
            }
        }
        onMounted(() => {
            window.addEventListener("keydown", keyListener);
        })
        onUnmounted(() => {
            window.removeEventListener("keydown", keyListener)
        })

        function swiperUpdate(swiper) {
            if(swiper.slides.length >= 3) {
                swiper.slides[2].style.opacity = 0;
            }
        }

        function decrementProductAmount(product, proposalId) {
            product.amount > 1 ? --product.amount: '';
            productChangeAmount(product, proposalId);
        }

        function incrementProductAmount(product, proposalId) {
            product.amount >= 1 ? ++product.amount : '';
            productChangeAmount(product,proposalId);
        }

        function productChangeAmount(product, proposalId) {
            if(product.amount > 0)
                axios.put(ApiHelper.getChangeProductAmountUrl(proposalId,product.id),{
                    "amount": product.amount
                },{
                    headers: authHelper.authHeader()
                })
                    .then(result => {
                        console.log('RESULT:',result)
                        projectInfo.value.designProposals.find((proposal,index) => {
                            if(proposal.id == result.data.id) {
                                projectInfo.value.designProposals[index] = result.data;
                            }
                        })
                    })
                    .catch(error => {
                        console.log(error);
                        let errorMessage = ApiHelper.getResponseMessage(error.response?.data?.code);
                        AlertHelper.show(alert, errorMessage, '', 'error');
                    })
        }

        function deleteProposalProduct(product,proposalId) {
            confirmDeleteProposalProduct.value.showModal(product,proposalId);
        }

        // @TODO Sprawdzić czy nie lepiej zrobić refreshProposal. W zależności co daje backend w response.
        function deleteProposalProductConfirmed(productId, proposalId, proposalData) {
            projectInfo.value.designProposals.find((proposal,index) => {
                if(proposal.id == proposalId) {
                    projectInfo.value.designProposals[index].totalValue = proposalData.totalValue;
                    projectInfo.value.designProposals[index].products.find((product,productIndex) => {
                        if(product.id == productId) {
                            projectInfo.value.designProposals[index].products.splice(productIndex, 1);
                            return true;
                        }
                    })
                }
            })
        }

        function refreshProposal(newProposal) {
            projectInfo.value.designProposals.find((proposal,index) => {
                if(proposal.id == newProposal.id) {
                    projectInfo.value.designProposals[index] = newProposal;
                }
            })
        }

        function addNewProductToProposal(proposal) {
            addProductToPropose.value.showModal(proposal);
        }

        function addProductToShoppingCart(proposalIndex) {
            const shoppingCart = new shoppingCartService();
            shoppingCart.addProductToShoppingCart(projectInfo.value.designProposals[proposalIndex].products)
                .then(result => {
                    emitter.emit('updateShoppingCart',result);
                    AlertHelper.show(alert,t('shopping_cart.success_add_product'))
                })
                .catch(error => {
                    console.log(error);
                    const errorMessage = ApiHelper.getResponseMessage(error.response?.data?.code);
                    AlertHelper.show(alert, errorMessage, '', 'error');
                })
        }

        return {
            exchangeModal,
            onSwiper,
            onSlideChange,
            breakpoints,
            sw,
            nextSlider,
            prevSlider,
            showRoomsParametersDialog,
            roomParametersModal,
            showExchangeDialog,
            spaceBetweenSliders,
            swiperUpdate,
            decrementProductAmount,
            incrementProductAmount,
            refreshProposal,
            deleteProposalProduct,
            confirmDeleteProposalProduct,
            deleteProposalProductConfirmed,
            addNewProductToProposal,
            addProductToPropose,
            addProductToShoppingCart,
            Role,
            auth,
        };
    },
}
</script>

<style scoped lang="scss">
@use "@/css/proposals";

.swiper-slide-active {
    z-index: 10;
}

.swiper {
    padding-bottom: 20px;
}

.proposals {
    &__wrapper {
        &-top {
            button {
                border: 1px solid #8E4F4F33;
                background-color: #8E4F4F1A;

                &:hover {
                    cursor: pointer;
                    background-color: #ad6f69;
                    color: white;
                    img {
                        filter: brightness(5);
                    }
                }
            }
        }
    }
    &__slider {
        &-products {
            height: auto !important;
            .product {
                position: relative;
                padding: 22px 13px;

                @media screen and (max-width: 1350px) {
                    justify-content: flex-start !important;
                }


                &>button {
                    position: absolute;
                    top: 20px;
                    right: 20px;
                    background-color: transparent;
                    border: none;
                    cursor: pointer;
                }
                &__button {
                    &-wrapper {
                        button {
                            cursor: pointer;
                        }
                    }
                }
                &__image {
                    //width: 100% !important;
                }
            }
        }

        &-item {
            height: auto;

            @media screen and (max-width: 1299px) {
                margin: 0 auto;
            }

            &-btn {
                cursor: pointer;
                &:hover {
                    background-color: #65a9b0;
                }
            }
        }
        &-top {
            .menu {
                width: 15px;
                ul {
                    @media screen and (max-width: 1299px) {
                        top: -2px;
                        right: 172px;
                    }
                    li {
                        a {
                            &:hover {
                                span {
                                    color: #ad6f69;
                                }
                            }
                            span {
                            }
                        }
                    }
                }
            }
        }

        &-add-product {
            width: 100%;
            background-color: #529096;
            border: none;
            cursor: pointer;

            img {
                filter: invert(1);
            }
        }
    }
}

.no-proposals {
    font-size: 2.5rem;
    text-align: center;

}
</style>